module.exports = __webpack_public_path__ + "7cafc7af5e3a1e87212799a5d9267bc7.svg";